var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebcollector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "595.28px",
    viewBox: "0 0 595.28 595.28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFED00",
    points: "318.471,137.748 318.489,137.748 352.316,137.78 367.651,79.935 263.466,79.843 162.287,461.453  162.288,461.453 318.448,137.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004F9F",
    points: "422.667,137.846 422.655,137.89 422.677,137.846 352.316,137.78 318.489,137.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004F9F",
    points: "162.288,461.453 162.287,461.454 232.637,461.519 318.448,137.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E30613",
    points: "321.496,519.462 321.5,519.448 321.493,519.462  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E30613",
    points: "407.331,195.693 422.655,137.89 422.667,137.846 318.489,137.748 318.471,137.748 318.448,137.833  232.637,461.519 217.302,519.363 217.303,519.363 373.502,195.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#004F9F",
    points: "373.502,195.662 217.303,519.363 217.302,519.365 321.493,519.462 321.5,519.448 477.693,195.759  407.331,195.693  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcollector);
export default __webpack_public_path__ + "static/media/webcollector.96a60c924f45bb4321ddb94690321275.svg";
export { ForwardRef as ReactComponent };